import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/lib/jenkins/workspace/ai-tools/removetext-web/apps/web/app/[locale]/(playground)/playground/view.tsx");
